<div>
  <img
    class="logo"
    src="{{ header !== null && !!header.icon ? header.icon : 'assets/img/logo/octiga-icon.png' }}"
  />
</div>
<div style="width: 70%; margin-bottom: 1rem">
  <h2 class="title">{{ header !== null && !!header.icon ? '' : 'Octiga ' }} Microsoft 365 Security Posture Report</h2>
  <span *ngIf="header !== null">{{ header.date.start }} - {{ header.date.end }} <span style="color: red">*</span></span>
</div>
<div>
  <h2>Client</h2>
  <span style="min-width: 290px; min-height: 45px" *ngIf="header !== null">{{ header.tenant }}</span>
</div>
